import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { loadingSkeleton } from "../../../styles/animations/loading-skeleton";

export const createProfileModalStyles = css`
  div[id="modal-container"] {
    min-width: 60%;
    max-width: fit-content;
  }
`;

export const customButtonStyles = css`
  min-height: 30px;
  height: auto;
  line-height: var(--lh-base);
  width: fit-content;
  padding: 6px 10px;
  border-radius: 5px;
  font-weight: 400;
`;

export const jobBtnStyles = css`
  ${customButtonStyles}
  border-color: var(--primary-dark-200);
  color: var(--primary-blue);
`;

export const Dashboard = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: 900px) {
    padding: 20px;
  }
`;

export const DashboardHeader = styled.h1`
  color: var(--primary-dark);
  font-family: Rubik;
  font-size: 1.286rem; // 18px
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Anchor = styled(Link)`
  color: var(--primary-dark);
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    color: var(--primary-dark-900);
    text-decoration: underline;
  }
`;

// horizontal scrolling
export const TableWrapper = styled.div`
  overflow-x: auto;
  width: 100%;

  @media (max-width: 900px) {
    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
    }
  }
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0 20px;
  width: 100%;
  min-width: 800px;
`;

export const TH = styled.th`
  color: var(--primary-dark-300);
  font-family: Rubik;
  font-size: var(--fs-sm); // 12 px
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  padding: 0 16px;
  white-space: nowrap;
  position: relative;

  &:first-child {
    padding-left: 30px;
    position: sticky;
    background-color: var(--primary-dark-50);
    left: 0;
    z-index: 10;

    /* Add shadow to indicate sticky behavior */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1));
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }

  text-align: ${({ $isCentered }) => $isCentered && "center"};
`;

export const TD = styled.td`
  padding: 16px;
  background-color: var(--primary-white);
  color: var(--primary-dark);
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: ${({ $isCentered }) => $isCentered && `center`};
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    padding-left: 30px;
    position: sticky;
    left: 0;
    z-index: 5;

    /* Add shadow when scrolling */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1));
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding-right: 24px;
  }
`;

export const SkeletonRow = styled.tr`
  height: 62px;
  ${loadingSkeleton()}
`;

export const SkeletonCell = styled.td`
  padding: 16px;
  height: 100%;
  width: ${({ width }) => width};

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    position: sticky;
    left: 0;
    z-index: 5;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
